export default "__VITE_ASSET__2kXS4Agl__"